// Types
import { EMPTY_OBJECT } from 'ezyvet-fe-helpers/dist/constant';
import { COMMITTED_VALUES } from './constants';
/**
 * Return the committed changes for an object
 *
 * @template T extends Committable<object>
 * @param values {T}
 *
 * @return {T}
 */
export var getCommitted = function (_a) {
    var _b = COMMITTED_VALUES, committedValues = _a[_b];
    // @todo make this recursivly build this, as sub-object can be comitted on the immediate changes are applicable
    if (committedValues === undefined) {
        return EMPTY_OBJECT;
    }
    return committedValues();
};
//# sourceMappingURL=getCommitted.js.map